import { render, staticRenderFns } from "./TitleButton.vue?vue&type=template&id=4d6713fa&scoped=true&"
import script from "./TitleButton.vue?vue&type=script&lang=js&"
export * from "./TitleButton.vue?vue&type=script&lang=js&"
import style0 from "./TitleButton.vue?vue&type=style&index=0&id=4d6713fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6713fa",
  null
  
)

export default component.exports